import React from 'react';
import ErrorIcon from '@material-ui/icons/Error';
import classes from './error.module.scss';

const Error = ({ errorMessage }) => {
  return (
    <div className={classes['error-container']}>
      <ErrorIcon className={classes.icon} />
      <span className={classes['error-text']}>{errorMessage}</span>
    </div>
  );
};

export default Error;
